import { CALL_API } from "redux-api-middleware";
import api from "apis/appraiser";
import {
  REQUEST_APPRAISERLIST,
  RECEIVE_APPRAISERLIST,
  ERROR_APPRAISERLIST,
  REQUEST_APPRAISER_MANAGERS,
  RECEIVE_APPRAISER_MANAGERS,
  ERROR_APPRAISER_MANAGERS,
  REQUEST_APPRAISER_CERTIFICATE,
  RECEIVE_APPRAISER_CERTIFICATE,
  ERROR_APPRAISER_CERTIFICATE,
  REQUEST_APPRAISER_DESIGNATION,
  RECEIVE_APPRAISER_DESIGNATION,
  ERROR_APPRAISER_DESIGNATION,
  REQUEST_APPRAISER_STATE,
  RECEIVE_APPRAISER_STATE,
  ERROR_APPRAISER_STATE,
  REQUEST_APPRAISER,
  RECEIVE_APPRAISER,
  ERROR_APPRAISER,
  REQUEST_APPRAISER_UPDATE,
  RECEIVE_APPRAISER_UPDATE,
  ERROR_APPRAISER_UPDATE,
  REQUEST_PAY_SUMMARY,
  RECEIVE_PAY_SUMMARY,
  ERROR_PAY_SUMMARY,
  REQUEST_ASSIGNABLE_APPRAISER_LIST,
  RECEIVE_ASSIGNABLE_APPRAISER_LIST,
  ERROR_ASSIGNABLE_APPRAISER_LIST,
  REQUEST_APPRAISER_EXCLUSION_SEARCH_RESULTS,
  RECEIVE_APPRAISER_EXCLUSION_SEARCH_RESULTS,
  ERROR_APPRAISER_EXCLUSION_SEARCH_RESULTS,
  REQUEST_MINIMAL_APPRAISER_LIST,
  RECEIVE_MINIMAL_APPRAISER_LIST,
  ERROR_MINIMAL_APPRAISER_LIST,
  RECEIVE_VALUATION_DIRECTORS,
  REQUEST_VALUATION_DIRECTORS,
  ERROR_VALUATION_DIRECTORS,
  RECEIVE_VALUATION_COORDINATORS,
  REQUEST_VALUATION_COORDINATORS,
  ERROR_VALUATION_COORDINATORS,
  CLEAR_APPRAISER_PROFILE,
} from "typeConstants";
import responseHandler from "responseHandler";
import { HTTP_GET, HTTP_POST, WebApiReduxRequest } from "tools/webservice";
import customerAppraiserExclusions from "apis/customerAppraiserExclusions";
import employeeApi from "apis/employee";
import * as employeeRoles from "typeConstants/employeeRoles";
import { COMPANYFILTER } from "typeConstants/rights";

const getAppraiserList = (hardRefresh, searchText) => {
  return function (dispatch, getState) {

    // check if we already have the list.
    let { appraiserList } = getState().appraiser;
    if (!hardRefresh) {
      if (Object.keys(appraiserList).length !== 0) {
        return dispatch({ type: RECEIVE_APPRAISERLIST, payload: appraiserList });
      }
    }

    dispatch({
      [CALL_API]: {
        endpoint: api.appraiserList(searchText),
        method: HTTP_GET,
        types: [
          REQUEST_APPRAISERLIST,
          {
            type: RECEIVE_APPRAISERLIST,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_APPRAISERLIST,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getCertificateList = () => {
  return function (dispatch, getState) {

    // check if we already have the list.
    let { certificateList } = getState().appraiser;
    if (Object.keys(certificateList).length !== 0) {
      return dispatch({ type: RECEIVE_APPRAISER_CERTIFICATE, payload: certificateList });
    }

    dispatch({
      [CALL_API]: {
        endpoint: api.getCertificateList(),
        method: HTTP_GET,
        types: [
          REQUEST_APPRAISER_CERTIFICATE,
          {
            type: RECEIVE_APPRAISER_CERTIFICATE,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_APPRAISER_CERTIFICATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getDesignationList = () => {
  return function (dispatch, getState) {

    // check if we already have the list.
    let { designationList } = getState().appraiser;
    if (Object.keys(designationList).length !== 0) {
      return dispatch({ type: RECEIVE_APPRAISER_DESIGNATION, payload: designationList });
    }

    dispatch({
      [CALL_API]: {
        endpoint: api.getDesignationList(),
        method: HTTP_GET,
        types: [
          REQUEST_APPRAISER_DESIGNATION,
          {
            type: RECEIVE_APPRAISER_DESIGNATION,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_APPRAISER_DESIGNATION,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getStateList = () => {
  return function (dispatch, getState) {

    // check if we already have the list.
    let { stateList } = getState().appraiser;
    if (Object.keys(stateList).length !== 0) {
      return dispatch({ type: RECEIVE_APPRAISER_STATE, payload: stateList });
    }

    dispatch({
      [CALL_API]: {
        endpoint: api.getStateList(),
        method: HTTP_GET,
        types: [
          REQUEST_APPRAISER_STATE,
          {
            type: RECEIVE_APPRAISER_STATE,
            payload: (action, state, res) =>
              res.json()
                .then(data => {

                  return data.map(x => (
                    {
                      id: x.id,
                      stateAbbreviation: x.abbreviation,
                      stateName: x.name
                    }));
                })
          }, {
            type: ERROR_APPRAISER_STATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getAppraiserProfile = (id) => {
  return function (dispatch, getState) {

    // check if we already have the appraiser profile for this id.
    let { appraiserProfile } = getState().appraiser;
    if (Object.keys(appraiserProfile).length !== 0
      && appraiserProfile.appraiserId === id) {
      return dispatch({ type: RECEIVE_APPRAISER, payload: appraiserProfile });
    }

    dispatch({
      [CALL_API]: {
        endpoint: api.getAppraiserProfile(id),
        method: HTTP_GET,
        types: [
          REQUEST_APPRAISER,
          {
            type: RECEIVE_APPRAISER,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_APPRAISER,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getAppraiserManagers = () => {
  return function (dispatch, getState) {

    // check if we already have the list.
    let { appraiserManagers } = getState().appraiser;
    if (appraiserManagers?.items?.length > 0) {
      return dispatch({ type: RECEIVE_APPRAISER_MANAGERS, payload: appraiserManagers });
    }

    // check if we can do this at all
    let rights = getState().user.profile.rights;
    if(rights.includes(COMPANYFILTER)) {
      return dispatch({ type: RECEIVE_APPRAISER_MANAGERS, payload: [] });
    }

    dispatch({
      [CALL_API]: {
        endpoint: api.getAppraiserManagers(),
        method: HTTP_GET,
        types: [
          REQUEST_APPRAISER_MANAGERS,
          {
            type: RECEIVE_APPRAISER_MANAGERS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return { items: data, fetched: true, type: "OPTIONS" };
                })
          }, {
            type: ERROR_APPRAISER_MANAGERS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const updateAppraiserProfile = (appraiserProfile) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.updateAppraiserProfile(appraiserProfile.appraiserId),
        method: HTTP_POST,
        body: JSON.stringify(appraiserProfile),
        types: [
          REQUEST_APPRAISER_UPDATE,
          {
            type: RECEIVE_APPRAISER_UPDATE,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    let message = appraiserProfile.appraiserId == 0 ? "New Appraiser Created" : "Appraiser Updated";
                    responseHandler.success(message, dispatch);
                  }, 0);
                  return data;
                })
          },
          {
            type: ERROR_APPRAISER_UPDATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return appraiserProfile;
            }
          }
        ]
      }
    })
  );
};

const getPaySummary = (appraiserNumber, payPeriodId) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.getPaySummary(appraiserNumber, payPeriodId),
        method: HTTP_GET,
        types: [
          REQUEST_PAY_SUMMARY,
          {
            type: RECEIVE_PAY_SUMMARY,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_PAY_SUMMARY,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

const getAppraiserListByAppraisalId = (appraisalId) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.getAppraiserListByAppraisalId(appraisalId),
        method: HTTP_GET,
        types: [
          REQUEST_ASSIGNABLE_APPRAISER_LIST,
          {
            type: RECEIVE_ASSIGNABLE_APPRAISER_LIST,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_ASSIGNABLE_APPRAISER_LIST,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

const getAppraiserExclusionSearchResults = (customerNumber, file, matchTypes) => {
  const data = new FormData();
  data.append("file", file);

  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: customerAppraiserExclusions.findAppraisers(customerNumber, matchTypes),
        method: HTTP_POST,
        body: data,
        requestType: "upload", // This will get picked up in the middlewares/genericHeaders/index.js and it will delete our Content-Type that it usually sets so the browser can generate a proper Content-Type
        types: [
          REQUEST_APPRAISER_EXCLUSION_SEARCH_RESULTS,
          {
            type: RECEIVE_APPRAISER_EXCLUSION_SEARCH_RESULTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    if (data.error) {
                      responseHandler.clientErrors(data.errorMessages, dispatch);
                    }
                  }, 0);
                  return data;
                })
          },
          {
            type: ERROR_APPRAISER_EXCLUSION_SEARCH_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return;
            }
          }
        ]
      }
    })
  );
};

const getMinimalAppraiserList = () => WebApiReduxRequest(
  REQUEST_MINIMAL_APPRAISER_LIST,
  RECEIVE_MINIMAL_APPRAISER_LIST,
  ERROR_MINIMAL_APPRAISER_LIST,
  HTTP_GET,
  api.getMinimalAppraiserList(),
);

const getValuationCoordinators = (getState, dispatch) => {
  // check if we already have the list.
  let { valuationCoordinators } = getState().appraiser;
  if (Object.keys(valuationCoordinators).length !== 0) {
    return dispatch({ type: RECEIVE_VALUATION_COORDINATORS, payload: valuationCoordinators });
  }

  return WebApiReduxRequest(
    REQUEST_VALUATION_COORDINATORS,
    RECEIVE_VALUATION_COORDINATORS,
    ERROR_VALUATION_COORDINATORS,
    HTTP_GET,
    employeeApi.getEmployeesByRoles([employeeRoles.VALUATION_QUALITY_ASSOCIATE])
  );
};

const getValuationDirectors = (getState, dispatch) => {
  // check if we already have the list.
  let { valuationDirectors } = getState().appraiser;
  if (Object.keys(valuationDirectors).length !== 0) {
    return dispatch({ type: RECEIVE_VALUATION_DIRECTORS, payload: valuationDirectors });
  }

  return WebApiReduxRequest(
    REQUEST_VALUATION_DIRECTORS,
    RECEIVE_VALUATION_DIRECTORS,
    ERROR_VALUATION_DIRECTORS,
    HTTP_GET,
    employeeApi.getManagersByEmployeeRoles([employeeRoles.VALUATION_QUALITY_ASSOCIATE])
  );
};

const clearAppraiserProfile = () => {
  return dispatch => (
    dispatch({
      type: CLEAR_APPRAISER_PROFILE
    })
  );
};

export {
  getAppraiserList,
  getAppraiserProfile,
  getAppraiserManagers,
  getValuationCoordinators,
  getValuationDirectors,
  updateAppraiserProfile,
  getCertificateList,
  getDesignationList,
  getStateList,
  getPaySummary,
  getAppraiserListByAppraisalId,
  getAppraiserExclusionSearchResults,
  getMinimalAppraiserList,
  clearAppraiserProfile,
};
